import { render, staticRenderFns } from "./DmMastr.vue?vue&type=template&id=51a28a2a&scoped=true&"
import script from "./DmMastr.vue?vue&type=script&lang=js&"
export * from "./DmMastr.vue?vue&type=script&lang=js&"
import style0 from "./DmMastr.vue?vue&type=style&index=0&id=51a28a2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a28a2a",
  null
  
)

export default component.exports